import {} from "lucide-react"

export default function Favoritesection() {
  return (
    <div className="space-y-6 p-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Meus Favoritos</h1>
        <p className="text-gray-500">Produtos que você salvou para comprar mais tarde</p>
      </div>

     {/* componente de card aq */}
    </div>
  )
}